import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import {
  ColorAction,
  OfficeAction,
  PurchaseAction,
  VehicleAction,
} from '../../store/actions';

class Form extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    authOfficeId: PropTypes.number,
    authOfficeName: PropTypes.string,
    colors: PropTypes.arrayOf(PropTypes.object),
    createPurchase: PropTypes.func,
    editPurchase: PropTypes.func,
    getColors: PropTypes.func,
    getOffices: PropTypes.func,
    getPurchase: PropTypes.func,
    getVehicles: PropTypes.func,
    offices: PropTypes.arrayOf(PropTypes.object),
    purchase: PropTypes.object,
    purchaseId: PropTypes.number,
    vehicles: PropTypes.arrayOf(PropTypes.object),
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.purchase);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.purchaseId) {
      this.props.getPurchase(this.props.purchaseId);
    }
    this.props.getColors({ office_id: this.state.office_id });
    this.props.getVehicles({ office_id: this.state.office_id });
  }

  componentDidUpdate(props, _state, _snapshot) {
    if (
      JSON.stringify(props.purchase) !== JSON.stringify(this.props.purchase)
    ) {
      this.setState({ ...this.getInitialState(this.props.purchase) });
    }
  }

  getInitialState(purchase) {
    const officeId = [this.props.authOfficeId, purchase?.office_id, '']?.find?.(
      i => i,
    );
    const officeSelected = [
      this.props.authOfficeId && {
        label: this.props.authOfficeName,
        value: this.props.authOfficeId,
      },
      purchase?.office?.id && {
        label: purchase?.office?.name,
        value: purchase?.office?.id,
      },
      '',
    ]?.find?.(i => i);
    return {
      chalan_number: purchase?.chalan_number || '',
      chassis_number: purchase?.chassis_number || '',
      color_id: purchase?.color_id || '',
      color_selected: purchase?.color?.id
        ? {
            label: purchase?.color?.name,
            value: purchase?.color?.id,
          }
        : '',
      engine_number: purchase?.engine_number || '',
      key_number: purchase?.key_number || '',
      office_id: officeId || '',
      office_selected: officeSelected || '',
      price: purchase?.price || '',
      purchased_at: purchase?.purchased_at || '',
      vehicle_id: purchase?.vehicle_id || '',
      vehicle_selected: purchase?.vehicle?.id
        ? {
            label: purchase?.vehicle?.model,
            value: purchase?.vehicle?.id,
          }
        : '',
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSelect(option, action) {
    const { _name, name } = action;
    const { value } = option;
    this.setState({ [name]: option, [_name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    if (this.props.purchaseId) {
      this.props.editPurchase(this.props.purchaseId, this.state);
    } else {
      this.props.createPurchase(this.state);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                {this.props.purchaseId ? 'Edit' : 'Create'} Purchase
              </h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                {!this.props.authHasOffice && (
                  <div className="form-row">
                    <div className="form-group col">
                      <label htmlFor="office_id">Office</label>
                      <Select
                        id="office_id"
                        isDisabled={this.props.authHasOffice}
                        name="office_selected"
                        onChange={(option, action) =>
                          this.onSelect(option, {
                            ...action,
                            _name: 'office_id',
                          })
                        }
                        onInputChange={value => {
                          value && this.props.getOffices({ query: value });
                        }}
                        options={this.props.offices}
                        placeholder="Select Office"
                        value={this.state.office_selected}
                      />
                    </div>
                  </div>
                )}
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="purchased_at">Purchase At</label>
                    <input
                      className="form-control"
                      id="purchased_at"
                      name="purchased_at"
                      onChange={this.onChange}
                      placeholder="Purchase At"
                      type="date"
                      value={this.state.purchased_at}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="vehicle_id">Vehicle</label>
                    <Select
                      id="vehicle_id"
                      name="vehicle_selected"
                      onChange={(option, action) =>
                        this.onSelect(option, {
                          ...action,
                          _name: 'vehicle_id',
                        })
                      }
                      onInputChange={value => {
                        value &&
                          this.props.getVehicles({
                            office_id: this.state.office_id,
                            query: value,
                          });
                      }}
                      options={this.props.vehicles}
                      placeholder="Select Vehicle"
                      value={this.state.vehicle_selected}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="color_id">Colour of Vehicle</label>
                    <Select
                      id="color_id"
                      name="color_selected"
                      onChange={(option, action) =>
                        this.onSelect(option, { ...action, _name: 'color_id' })
                      }
                      onInputChange={value => {
                        value &&
                          this.props.getColors({
                            office_id: this.state.office_id,
                            query: value,
                          });
                      }}
                      options={this.props.colors}
                      placeholder="Colour of Vehicle"
                      value={this.state.color_selected}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="price">Price</label>
                    <input
                      className="form-control"
                      id="price"
                      name="price"
                      onChange={this.onChange}
                      placeholder="Price"
                      type="number"
                      value={this.state.price}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="chalan_number">Chalan Number</label>
                    <input
                      className="form-control"
                      id="chalan_number"
                      name="chalan_number"
                      onChange={this.onChange}
                      placeholder="Chalan Number"
                      type="text"
                      value={this.state.chalan_number}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="chassis_number">Chassis Number</label>
                    <input
                      className="form-control"
                      id="chassis_number"
                      name="chassis_number"
                      onChange={this.onChange}
                      placeholder="Chassis Number"
                      type="text"
                      value={this.state.chassis_number}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-4">
                    <label htmlFor="engine_number">Engine Number</label>
                    <input
                      className="form-control"
                      id="engine_number"
                      name="engine_number"
                      onChange={this.onChange}
                      placeholder="Engine Number"
                      type="text"
                      value={this.state.engine_number}
                    />
                  </div>
                  <div className="form-group col-4">
                    <label htmlFor="key_number">Key Number</label>
                    <input
                      className="form-control"
                      id="key_number"
                      name="key_number"
                      onChange={this.onChange}
                      placeholder="Key Number"
                      type="text"
                      value={this.state.key_number}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  authHasOffice: !!state?.auth?.office,
  authOfficeId: state?.auth?.office?.id,
  authOfficeName: state?.auth?.office?.name,
  colors: [{ label: 'No Color', value: '' }]?.concat?.(
    state?.color?.list?.data?.map?.(row => ({
      label: row.name,
      value: row.id,
    })),
  ),
  offices: state?.office?.list?.data?.map?.(row => ({
    label: row.name,
    value: row.id,
  })),
  purchase: state?.purchase?.detail,
  purchaseId: Number(props?.match?.params?.id),
  vehicles: [{ label: 'No Vehicle', value: '' }]?.concat?.(
    state?.vehicle?.list?.data?.map?.(row => ({
      label: row.model,
      value: row.id,
    })),
  )
});

const mapDispatchToProps = dispatch => ({
  createPurchase: data => dispatch(PurchaseAction.createPurchase(data)),
  editPurchase: (id, data) => dispatch(PurchaseAction.editPurchase(id, data)),
  getColors: params => dispatch(ColorAction.getColors(params)),
  getOffices: params => dispatch(OfficeAction.getOffices(params)),
  getPurchase: id => dispatch(PurchaseAction.getPurchase(id)),
  getVehicles: params => dispatch(VehicleAction.getVehicles(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
